import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=29be5049&scoped=true&"
import script from "./FAQ.vue?vue&type=script&lang=ts&"
export * from "./FAQ.vue?vue&type=script&lang=ts&"
import style0 from "./FAQ.vue?vue&type=style&index=0&id=29be5049&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29be5049",
  null
  
)

export default component.exports